import { combineReducers } from 'redux';
import * as R from 'ramda';
import _ from 'lodash';
import I18n from 'i18n-js';
import C from '../../../constants/customer-po/current/editOrder';

const showing = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case C.SHOW_MODAL:
      return true;
    case C.HIDE_MODAL:
      return false;
    default:
      return state;
  }
};

const fetchingDetail = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case C.FETCH_DETAIL:
      return true;
    case C.CANCEL_FETCH_DETAIL:
      return false;
    default:
      return state;
  }
}

const rawOrder = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return payload;
    default:
      return state;
  }
};

const customerPO = (state = '', action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.path(['customerPO'], payload);
    case C.CHANGE_CUSTOMER_PO:
      return _.trimStart(payload);
    default:
      return state;
  }
};

const selectableCustomers = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_SELECTABLE_CUSTOMERS:
      return payload;
    default:
      return state;
  }
};

const selectedCustomer = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.path(['customer'], payload);
    case C.CHANGE_SELECTED_CUSTOMER:
      return payload;
    default:
      return state;
  }
};

const orderDate = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.path(['orderDate'], payload);
    case C.CHANGE_ORDER_DATE:
      return payload;
    default:
      return state;
  }
};

const exFactory = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.path(['exFactory'], payload);
    case C.CHANGE_EX_FACTORY:
      return payload;
    default:
      return state;
  }
};

const ihDate = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.path(['ihDate'], payload);
    case C.CHANGE_IH_DATE:
      return payload;
    default:
      return state;
  }
}

const description = (state = null, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.pathOr('', ['description'], payload);
    case C.CHANGE_DESCRIPTION:
      return payload;
    default:
      return state;
  }
}

const completed = (state = false, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return !!R.path(['isCompleted'], payload);
    case C.CHANGE_CHECKED_COMPLETE:
      return payload;
    default:
      return state;
  }
};

const note = (state = '', action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_ORDER_DETAIL:
      return R.pathOr('', ['note'], payload);
    case C.CHANGE_NOTE:
      return payload;
    default:
      return state;
  }
}

const errors = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case C.CHANGE_VALIDATE_ORDER_NAMES:
      return {...state, 'names': payload };
    case C.CHANGE_ORDER_DETAIL:
      return {...state, 'ownName': R.path(['customerPO'], payload)}
    case C.CHANGE_CUSTOMER_PO: {
      const ownName = R.path(['ownName'], state);
      const names = R.pathOr([], ['names'], state).filter(x => x !== ownName);
      return {
        ...state, 
        'customerPO': !payload ?
          `Please input customerPO`:
          _.find(names, x => x.toLowerCase() === payload.toLowerCase()) ? I18n.t('ErrorMessages.OrderHaveAlreadyExist'): null,
      };
    }
    case C.CHANGE_SELECTED_CUSTOMER:
      return {...state, 'selectedCustomer': !payload ? 'Please select a customer': null };
    default:
      return state;
  }
}

const submiting = (state = false, action) => {
  const { type } = action;
  switch (type) {
    case C.SUBMIT_ORDER:
      return true;
    case C.CANCEL_SUBMIT_ORDER:
      return false;
    default:
      return state;
  }
}

const combined = combineReducers({
  showing,
  fetchingDetail,
  rawOrder,
  customerPO,
  selectableCustomers,
  selectedCustomer,
  orderDate,
  exFactory,
  ihDate,
  description,
  completed,
  note,
  errors,
  submiting,
});


export default (state, action) => {
  const { type } = action;
  if (type === C.RESET_DATA) {
    return {};
  }
  return combined(state, action);
};

